var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileReelIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7304_64386)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.1416 1.82031L6.90581 0.878202L9.6183 5.95765L7.85409 6.89976L5.1416 1.82031Z",
    fill: "url(#paint0_linear_7304_64386)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.959 1.78125L12.7232 0.839139L15.4556 5.95591L13.6914 6.89802L10.959 1.78125Z",
    fill: "url(#paint1_linear_7304_64386)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7255 0.765625H5.27837C2.36765 0.765625 0 3.2073 0 6.20408V15.3312C0 18.328 2.36765 20.7656 5.27837 20.7656H14.7216C17.6323 20.7656 20 18.328 20 15.3312V6.20408C20.0039 3.2073 17.6363 0.765625 14.7255 0.765625ZM5 2.76562H15C16 2.76562 18 4.76562 18 5.7616H2C2 4.76562 4 2.76562 5 2.76562ZM14.7216 18.7656H5.27837C4 18.7656 2 16.7656 2 15.3272V7.80724L10 7.76562H18V15.3312C18 16.7656 16 18.7656 14.7216 18.7656Z",
    fill: "url(#paint2_linear_7304_64386)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7656 12.6897L8.36719 9.43971C7.99609 9.21705 7.51563 9.33814 7.28906 9.70924C7.21484 9.83033 7.17578 9.97096 7.17578 10.1116V16.6116C7.17578 17.0452 7.52734 17.3967 7.96094 17.3967C8.10547 17.3967 8.24219 17.3577 8.36719 17.2835L13.7656 14.0335C14.1367 13.8108 14.2578 13.3264 14.0352 12.9553C13.9687 12.846 13.875 12.7522 13.7656 12.6897ZM8.74609 15.2249V11.5022L11.8398 13.3655L8.74609 15.2249Z",
    fill: "url(#paint3_linear_7304_64386)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7304_64386",
    x1: 8.33915,
    y1: 7.64478,
    x2: 10.127,
    y2: 6.54885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.111685,
    stopColor: "#F72585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FE5D26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7209B7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7304_64386",
    x1: 14.1795,
    y1: 7.64879,
    x2: 15.9679,
    y2: 6.5536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.111685,
    stopColor: "#F72585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FE5D26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7209B7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7304_64386",
    x1: 0.769228,
    y1: 23.8418,
    x2: 21.178,
    y2: 20.3461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.111685,
    stopColor: "#F72585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FE5D26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7209B7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7304_64386",
    x1: 7.44389,
    y1: 18.6378,
    x2: 14.6091,
    y2: 17.5774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.111685,
    stopColor: "#F72585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FE5D26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7209B7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7304_64386"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.765625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileReelIcon);
export default __webpack_public_path__ + "static/media/profileReelIcon.e2747af65889c1acb43f36b05e3a291b.svg";
export { ForwardRef as ReactComponent };